import { ThemeColors } from '~/themes/colors'

interface TransferHeaderColors {
  Input: {
    Background: ThemeColors
    Border: ThemeColors
    Placeholder: {
      FontColor: ThemeColors
    }
  }
}

export const transferHeaderColors: TransferHeaderColors = {
  Input: {
    Background: {
      default: 'achromatic.transparent',
    },
    Border: {
      default: 'gray.500',
    },
    Placeholder: {
      FontColor: {
        default: 'gray.600',
      },
    },
  },
}
